import { Tooltip } from 'antd';
import React from 'react';

export interface MapButtonProps {
  id: string;
  className: string;
  callback: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  tooltipText: string;
}

const MapButton: React.FC<MapButtonProps> = ({
  id,
  className,
  callback,
  children,
  tooltipText,
}) => {
  return (
    <Tooltip placement="left" title={tooltipText}>
      <button
        id={id}
        type="button"
        onClick={callback}
        className={className}
        data-testid={`${id}_button`}
        name={id}
      >
        {children}
      </button>
    </Tooltip>
  );
};

export default MapButton;
